<template>
    <mainUi :pageRouterQuery="pageRouterRun" :pageRouterPath="typeRun"></mainUi>
  </template>
  
  <script>
  
  import mainUi from '@/components/main.vue'
  export default {
    name: 'home',
    components: {
        mainUi
    },
    props: {
      msg: String
    },
    computed:{
        pageRouterRun(){
            let obj = this.$route.query
            return obj
        },
        typeRun(){
            return 'home'
        }
    },
    data(){
        return {
            slide: 0,
            sliding: null,
            contentText:{
                subText:"企业规划",
                textList:['第一阶段2022年-2023年',
'陕西、山西、河南3个省份，省市区三级、六个部门政策查询。',
'（1）其他20个省份、5个自治区、4个直糖市，省市区三级、六个部门政策查询。',
'（2）陕西省10个区县建立业务联络点(区县级)。3个省会城市建立业务联络点(市级)。',
'第二阶段2024年-2025年',
'（1）全国建立5个业务联络点(市级)。以省会城市为主',
'（2）陕西省区县建立业务联络点不低于100个(区县级)',
'第三阶段2026年-2027年',
'（1）公司全国不低于10个省会城市建立联络点或者子公司',
'（2）西部省会城市建立自己的分子公司']
            },
            layoutMap:[{
                title:"",
                type:"text",
                content:{
                    subText:"企业规划",
                    textList:['第一阶段2022年-2023年',
'陕西、山西、河南3个省份，省市区三级、六个部门政策查询。',
'（1）其他20个省份、5个自治区、4个直糖市，省市区三级、六个部门政策查询。',
'（2）陕西省10个区县建立业务联络点(区县级)。3个省会城市建立业务联络点(市级)。',
'第二阶段2024年-2025年',
'（1）全国建立5个业务联络点(市级)。以省会城市为主',
'（2）陕西省区县建立业务联络点不低于100个(区县级)',
'第三阶段2026年-2027年',
'（1）公司全国不低于10个省会城市建立联络点或者子公司',
'（2）西部省会城市建立自己的分子公司']
                }
            },
            {
                title:"行业专业现状",
                type:"list",
                content:[]
            }]
        }
    },
    methods:{
        onSlideStart(slide) {
            this.sliding = true
        },
        onSlideEnd(slide) {
            this.sliding = false
        }
    }
  }
  </script>
  
  <!-- Add "scoped" attribute to limit CSS to this component only -->
  <style lang="scss" scoped>
 .search-bar{
    justify-content: center;
    position: relative;
    top: -40px;
    border-radius: 8px;
    height: 80px;
    list-style: none;
    & > li{
        width: calc(100% - 40px);
        form{
            display: flex;
            justify-content: space-between;
            button{
                width: 140px;
                margin-left: 10px;
            }
        }
    }
 }
  </style>
  